import { NoteIcon } from './NoteIcon';

/**
 * author: Austin Andrews
 * id 5E1DF73F-AEF5-48F8-B766-419FBB05C5D0
 * name note
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note.svg
 * tags
 */
export const StickyNoteIcon = NoteIcon;
export default StickyNoteIcon